<!--
  アクティビティログの表示
-->
<template>
  <v-main class="pa-0">
    <div class="pa-5 pagetitle">アクティビティログ</div>
    <v-card v-if="displayque.length == 0">
      <v-card-text
        >このユーザーにはアクティビティログがありません。</v-card-text
      >
    </v-card>
    <v-list id="activitylog" class="pa0">
      <v-list-item v-for="activity in displayque" :key="activity.id">
        <v-card
          class="mx-auto mt-5"
          color="#DCDCDC"
          width="90%"
          min-height="20"
          elevation="0"
          tile
          v-if="activity.isymd"
        >
          <p class="mb-0">
            {{ activity.jdate.getFullYear() }}年{{
              activity.jdate.getMonth() + 1
            }}月{{ activity.jdate.getDate() }}日
          </p>
        </v-card>
        <v-card class="mx-auto my-0" width="90%" min-height="40" tile v-else>
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-img
                  v-if="activity.logclass == 'ideapost'"
                  src="../../../assets/svg/5040.svg"
                  width="30px"
                ></v-img>
                <v-img
                  v-else-if="activity.logclass == 'like'"
                  src="../../../assets/svg/5001.svg"
                  width="30px"
                ></v-img>
                <v-img
                  v-else
                  src="../../../assets/svg/5032.svg"
                  width="30px"
                ></v-img>
              </v-col>
              <p class="mb-0 d-flex flex-column">
                <span style="font-size: 14px"
                  >{{
                    activity.jdate.getHours().toString().padStart(2, "0")
                  }}：{{
                    activity.jdate.getMinutes().toString().padStart(2, "0")
                  }}</span
                >
                Lid「{{ lid[ activity.lidid] }}」にて
                <span
                  v-if="activity.logclass == 'ideapost'"
                  style="font-size: 16px"
                  >アイデア「{{ activity.text }}」を投稿しました。</span
                >
                <span
                  v-else-if="activity.logclass == 'like'"
                  style="font-size: 16px"
                  >アイデアにいいねをしました。</span
                >
                <span
                  v-else-if="activity.logclass == 'proposals'"
                  style="font-size: 16px"
                  >案を投稿しました。</span
                >
                <span
                  v-else-if="activity.logclass == 'comments'"
                  style="font-size: 16px"
                  >コメントをしました。</span
                >
                <span
                  v-else-if="activity.logclass == 'amendments'"
                  style="font-size: 16px"
                  >修正提案を投稿しました。</span
                >
                <span v-else style="font-size: 16px">
                  {{ activity.logclass }}
                </span>
              </p>
            </v-row>
          </v-container>
        </v-card>
      </v-list-item>
    </v-list>
    <v-card height="200" elevation="0">
    </v-card>
  </v-main>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  data() {
    return {
      db: firebase.firestore(),
      displayque: [],
      lid:{}
    };
  },
  components: {},
  created(){
    this.getLid();
  },
  watch: {
    profuid: function (profuid) {
      this.getlog()
    },
  },
  mounted() {
    this.getlog();
  },
  props: ["profuid"],
  methods: {
    getlog(logclass = null) {
      let myque = [];
      if (logclass == null) {
        let usedday = [];
        const collection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.profuid)
          .collection("activity")
          .orderBy("date", "desc")
          .limit(20);
        collection
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let logdata = doc.data();
              logdata.jdate = logdata.date.toDate();
              logdata.ymd =
                logdata.jdate.getFullYear() * 10000 +
                (logdata.jdate.getMonth() + 1) * 100 +
                logdata.jdate.getDate();
              if (!usedday.includes(logdata.ymd)) {
                let ymddata = {
                  isymd: true,
                  jdate: logdata.jdate,
                  date: logdata.date,
                };
                myque.push(ymddata);
                usedday.push(logdata.ymd);
              }
              // doc.data() is never undefined for query doc snapshots
              logdata.isymd = false;
              myque.push(logdata);
            });
          })
          .catch((error) => {
            console.error(
              "アクティビティログの取得でエラーが発生しました",
              error
            );
          });
      } else if (logclass in ["idea"]) {
        let collection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.profuid)
          .collection("activity")
          .orderBy("date", "desc");
        collection
          .where("logclass" == logclass)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              myque.push(doc.data());
            });
          })
          .catch((error) => {
            console.log(
              "アクティビティログの取得でエラーが発生しました。絞り込み：",
              logclass,
              error
            );
          });
      }
      this.displayque = myque;
    },
    
    getLid() {
      const basecollection = this.db
        .collection("0")
        .where("isActive", "==", true);
      basecollection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // Lidごと
          if (!doc.data().config) {
            this.lid[doc.id] = doc.data().title
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.pagetitle {
  font-size: large;
  color: #707070;
}
* {
  font-family: mplus-2c-medium;
}
</style>